import { PERSONAL_PAN_REGEX, EMAIL_REGEX, PAN_REGEX } from 'utils/regexes';
import { ValidationSchema } from 'forms';
import { FormFields } from './types';

const PAN_PATTERN = new RegExp(PAN_REGEX);

const validateEmail = (email: string): boolean => {
  const emailRegex = new RegExp(EMAIL_REGEX);
  return emailRegex.test(email);
};

export const getValidationSchema = (
  isPersonalPanValidationEnabled: boolean,
): ValidationSchema<FormFields> => {
  return {
    name: (formData) => (!formData.name?.trim() ? 'Employee name is required' : null),
    email_id: (formData) => {
      if (formData.email_not_present) {
        return null;
      }
      if (formData.email_id && !validateEmail(formData.email_id)) {
        return 'Please enter a valid email address';
      }
      if (!formData.email_id) {
        return 'Email address is required';
      }
      return null;
    },
    hire_date: (formData) => (!formData.hire_date ? 'Hire date is required' : null),
    designation: (formData) => (!formData.designation?.trim() ? 'Designation is required' : null),
    pan: (formData) => {
      if (!formData.pan?.trim()) {
        return 'PAN is required';
      }
      if (isPersonalPanValidationEnabled && !PERSONAL_PAN_REGEX.test(formData.pan)) {
        return 'Please enter a valid personal PAN';
      }
      if (!isPersonalPanValidationEnabled && !PAN_PATTERN.test(formData.pan)) {
        return 'Please enter a valid PAN';
      }
      return null;
    },
  };
};
